import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// import { VueClipboard } from "@soerenmartius/vue3-clipboard"; //https://www.npmjs.com/package/@soerenmartius/vue3-clipboard

// import AppConfig from "@/config/vueconfig.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import Tracking from "@/plugins/Tracking.js";
import Filter from "@/plugins/Filter.js";

// vendors
import './index.css';
import "@splidejs/splide/dist/css/splide.min.css";
import VueClickAway from "vue3-click-away";

// directives
import { ElementBoundaryDirective } from './directives/ElementBoundaryDirective';

createApp(App)
    .use(store)
    .use(router)
    .use(Tracking)
    .use(Filter)
    .use(VueClickAway)
    // .use(VueClipboard)
    .mixin(ErrorApiMixin)
    .directive("el-boundary", ElementBoundaryDirective)
    .mount('#app')
